// extracted by mini-css-extract-plugin
export var container = "CardCarousel-module--container--f6f14";
export var hidden = "CardCarousel-module--hidden--d4a90";
export var item = "CardCarousel-module--item--14efb";
export var nav = "CardCarousel-module--nav--f6285";